import React from 'react'
import img2030 from '../components/images/dpurplle.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2030} alt='purplle' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Purplle Account Management Overview
                    </h2>
                    <p>Elevate your sales on Purple with our comprehensive account management services designed to enhance your presence and drive profitability. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b> Create detailed listings with accurate descriptions, quality images, and strategic keywords.. </li>
                <li><b>•	Advertising Campaign:</b>Launch targeted ads to boost product visibility and drive sales. </li>
                <li><b>•	Coupons:</b> Develop and manage discount coupons to promote purchases and customer loyalty. </li>
                <li><b>•	Promotion:</b> Utilize special deals and offers to enhance visibility and increase sales.</li>
                <li><b>•	Brand Registry:</b>Assist in brand registration for IP protection and increased recognition. </li>
                <li><b>•	Category Approval:</b> Guide through approvals for specific or restricted categories. </li>
                <li><b>•	GTIN Exemption:</b>: Facilitate GTIN exemptions for streamlined product labeling.</li>
                <li><b>•	Account Health:</b> Maintain account health to comply with Purple’s policies and standards. </li>
                <li><b>•	Order Processing:</b> Oversee the entire order process from receipt to delivery. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate transaction records and resolve discrepancies. </li>
                <li><b>•	Keyword Optimization:</b> Optimize keywords for better search rankings and visibility.</li>
                <li><b>•	Basic Training:</b>Provide essential training to effectively manage your Purple account. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to enhance sales through optimized listings and promotions.</li>
            </ul>
        </>
    )
}

export default events